module.exports = __webpack_public_path__ + "img/instagram-icon.7da5e21d.svg";